import React, { useRef, useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import Header from './new_header';
import { useNavigate } from "react-router-dom";
import FullWidthImage from './FullWidthVideo';


const ContactForm = () => {
  const form = useRef();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  useEffect(() => {
    emailjs.init('a-aM5YaMiveOA2hsH');
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const privacyCheckbox = form.current.querySelector('input[type="checkbox"]');
    if (!privacyCheckbox.checked) {
      setErrorMessage('Please agree to the privacy policy');
      return;
    }
    setLoading(true);
    setErrorMessage('');
    try {
      await emailjs.sendForm(
        'service_9ir49kr',
        'template_do7l63m',
        form.current
      );
      setSuccessMessage(true);

      form.current.reset();

      setTimeout(() => {
        setSuccessMessage(false);
      }, 5000);
    } catch (error) {
      setErrorMessage('Failed to send form. Please try again.');
      console.error('EmailJS Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.mainWrapper}>
      {/* CSS Injection for complex styling */}
      <style>{`
        .container {
          font-family: DelightReg;
          max-width: 640px;
          margin: 0 auto;
          background-color: #ededed;
          border-radius: 32px;
          padding: 48px;
          color: black;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        }

        .form-header h2 { margin: 0 0 8px 0; font-size: 24px; font-weight: 600; }
        .form-header p { margin: 0 0 32px 0; color: black; font-size: 14px; }

        .form-group { margin-bottom: 24px; display: flex; flex-direction: column; gap: 8px; }
        .form-label { font-size: 16px; font-weight: 500; color: black; }

        .input-field {
          background-color: rgba(233, 231, 231, 1);;
          border: 1px solid transparent;
          font-family: DelightReg;
          border-radius: 12px;
          padding: 14px 16px;
          color: black;
          font-size: 14px;
          outline: none;
          transition: border 0.2s;
        }

        .input-field:focus { border-color: #404040; }
        .input-field::placeholder { color: #4a4a4a; }

        .grid-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 24px; }

        select.input-field {
          appearance: none;
          background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='grey' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
          background-repeat: no-repeat;
          background-position: right 1rem center;
          background-size: 1em;
        }

        .checkbox-container { display: flex; gap: 12px; margin: 32px 0; align-items: flex-start; }
        .checkbox-container input { width: 18px; height: 18px; border-radius: 4px; accent-color: #6366f1; cursor: pointer; margin-top: 2px; }
        .checkbox-text { font-size: 13px; color: #525252; line-height: 1.5; }

        .submit-btn {
          width: 100%;
          background-color: #1a1a1a;
          color: white;
          border: 1px solid #333;
          padding: 14px;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
        }

        .submit-btn:disabled {
        opacity:0.6;
        cursor: not-allowed;
        }
        .submit-btn:hover:not(:disabled){
        opacity: 0.9;
        }

        .success-message {
        position:fixed;
        top:20px;
        right:20px;
        background-color:#10b981;
        color:white;
        padding:16px 24px;
        border-radius:8px;
        box-shadow:0 4px 12px rgba(0, 0, 0, 0.15);
        z-index:1000;
        animation:slideIn 0.3s ease-out;
        }
        .error-message{
        background-color:#ef4444;
        color:white;
        padding:12px 16px;
        border-radius:8px;
        margin-bottom:16px;
        font-size:14px;
        }

        @keyframes slideIn {
        from {
        transform:translateX(400px);
        opacity:0;
        }
        to {
        transform:translateX(0);
        opacity:1;
        }
        }

        @media (max-width: 768px) {
          .grid-row { grid-template-columns: 1fr; }
          .success-message {right:10px; left:10px}
        }

        /* Footer Section Styling */
        .footer-container {
          max-width: 1300px;
          width: calc(100% - 40px);
          margin: 0 auto 20px auto;
          background-color: rgba(233, 231, 231, 1);
          padding: 30px clamp(20px, 3vw, 80px) 30px;
          border-radius: 40px;
        }

        .footer-top-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr); 
          gap: 40px;
          margin-bottom: 50px;
        }

        .footer-col h4 {
          font-size: 15.5px;
          letter-spacing: 0.05em;
          margin-bottom: 10px;
          color: #000;
        }

        .footer-col ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-col li {
          font-size: 15.1px;
          color: rgba(0,0,0,0.4);
          margin-bottom: 10px;
          cursor: pointer;
        }

        .footer-col li:hover {
          opacity: 0.6;
        }

        .footer-bottom {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          padding-top: 40px;
        }

        .brand-section {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .footer-logo {
          font-weight: 800;
          font-size: 24px;
          display: flex;
          align-items: center;
          gap: 10px;
          letter-spacing: -0.02em;
        }

        .copyright {
          font-size: 14px;
          color: rgba(0,0,0,0.4);
          margin-top:-50px
        }

        .info-section {
          max-width: 500px;
        }

        .social-icons {
          display: flex;
          gap: 20px;
          margin-bottom: 20px;
          font-size: 1.5rem;
        }

        .description-text {
          font-size: 14px;
          line-height: 1.6;
          color: rgba(0,0,0,0.5);
          text-align: left;
        }

        @media (max-width: 900px) {
          .footer-top-grid { grid-template-columns: 1fr 1fr; }
          .footer-bottom { flex-direction: column; align-items: flex-start; gap: 40px; }
          .info-section { text-align: left; }
        }
      `}</style>

      {/* Hero Section with Image Background */}
      <div style={styles.heroSection}>
        <div style={{ marginBottom: '40px' }}>
          <Header />
        </div>
        <div className="container">
          <div className="form-header">
            <h2>Get in touch</h2>
            <p>Leave your information and we will get back to you.</p>
          </div>

          {errorMessage && <div className="error-message">{errorMessage}</div>}

          <form ref={form} onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Work email</label>
              <input className="input-field" type="email" name="email" placeholder="e@tesla.com" required />
            </div>

            <div className="form-group">
              <label className="form-label">Company name</label>
              <input className="input-field" type="text" name="company" placeholder="Acme Inc" />
            </div>

            <div className="form-group">
              <label className="form-label">Tell us more about you and how you want to use rushcut</label>
              <textarea className="input-field" name="message" rows="4" style={{ resize: 'none' }} placeholder="We are DTC brand and need to ..."></textarea>
            </div>

            <div className="grid-row">
              <div className="form-group">
                <label className="form-label">Company size</label>
                <select className="input-field" name="company_size">
                  <option value="">Select company size</option>
                  <option value="1-10">1-10</option>
                  <option value="11-50">11-50</option>
                  <option value="51-200">51-200</option>
                  <option value="200+">200+</option>
                  {/* Add more options as needed */}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Marketing team size</label>
                <input className="input-field" type="text" name="team_size" placeholder="How many in your team?" />
              </div>
            </div>

            <div className="grid-row">
              <div className="form-group">
                <label className="form-label">Industry</label>
                <select className="input-field" name="industry">
                  <option value="">Select business area</option>
                  <option value="E-commerce">E-commerce</option>
                  <option value="SaaS">SaaS</option>
                  <option value="Agency">Agency</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Company location</label>
                <select className="input-field" name="location">
                  <option value="">Select HQ location</option>
                  <option value="USA">USA</option>
                  <option value="Europe">Europe</option>
                  <option value="Asia">Asia</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>

            <div className="checkbox-container">
              <input type="checkbox" id="privacy-checkbox" required />
              <label htmlFor="privacy-checkbox" className="checkbox-text">
                I agree to Rushcut sending me marketing communication, as described in our <span style={{ textDecoration: 'underline' }}>Privacy & Cookie policy</span>.
              </label>
            </div>

            <button className="submit-btn" type="submit" disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </form>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer-container">
        <div className="footer-top-grid">
          <div className="footer-col">
            <h4>Features</h4>
            <ul>
              <li>reference Library</li>
              <li>AI Image Generation</li>
              <li>Storyboards</li>
              <li>Moodboards</li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>rushcut for</h4>
            <ul>
              <li onClick={() => navigate("/lets-talk")}>Enterprise</li>
            </ul>
          </div>
          <div className="footer-col">
            <ul>
              {/* <li>Terms of Service</li>
              <li>Careers</li> */}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="brand-section">
            {/* <div className="footer-logo">
              <img
                src="./images/black red dot.png" // Replace with actual Kive logo path (e.g., black/red variant if available)
                alt="Kive Logo"
                style={{ height: 'auto', width: '200px' }}
              />
            </div> */}
            <div className="copyright">Copyright © 2026 rushcut</div>
          </div>

          <div className="info-section">
            {/* <div className="social-icons">
              <i className="fab fa-instagram"></i>
              <i className="fab fa-twitter"></i>
              <i className="fab fa-linkedin"></i>
            </div> */}
            <p className="description-text">
              Rushcut is an AI tool connected to the world’s largest database of Ads and Movie references. It helps executives storyboard their ideas well before going to their agency and production houses. Brands work with us to reduce the time to creative execution, and cut down the back and forth in approving creative vision.
            </p>
          </div>
        </div>
      </footer>
      <FullWidthImage
        src="./images/black red dot.png"
        alt="rushcut"
      />
      {successMessage && (
        <div className="success-message">
          ✓ Form submitted successfully! We'll get back to you soon.
        </div>
      )}
    </div>
  );
};

const styles = {
  mainWrapper: {
    backgroundColor: '#ededed',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  heroSection: {
    width: '100%',
    padding: '80px 20px',
    backgroundImage: 'url("./images/cubg.webp")', // Update with actual path
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    flex: 1,
  },
};

export default ContactForm;